var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.618 4.855c.015.212.015.423.015.637 0 6.506-4.953 14.01-14.01 14.01v-.004a13.942 13.942 0 0 1-7.548-2.207 9.885 9.885 0 0 0 7.287-2.041 4.93 4.93 0 0 1-4.6-3.419 4.912 4.912 0 0 0 2.223-.085 4.924 4.924 0 0 1-3.95-4.826v-.062c.685.38 1.451.591 2.235.615A4.932 4.932 0 0 1 1.746.898a13.975 13.975 0 0 0 10.148 5.144 4.928 4.928 0 0 1 8.39-4.49A9.873 9.873 0 0 0 23.411.357a4.941 4.941 0 0 1-2.165 2.723 9.787 9.787 0 0 0 2.828-.775 9.992 9.992 0 0 1-2.456 2.55z"}));
}

Twitter.defaultProps = {"viewBox":"0 0 24 19.502","style":{"enableBackground":"new 0 0 24 19.502"},"xmlSpace":"preserve"};

module.exports = Twitter;

Twitter.default = Twitter;
